// extracted by mini-css-extract-plugin
module.exports = {"text":"NotFound_text__27Ljn","image":"NotFound_image__2d7UH"};